import { styled } from '@nykaa/ui-components';
import { keyframes } from '@emotion/core';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

interface IBannerContainerProps {
  pageType?: string;
}

export const BannerContainer = styled.div<IBannerContainerProps>`
  width: 100%;
  margin: ${({ theme }) => theme.spacing.spacing120} 0;
  box-sizing: border-box;
  animation: ${fadeIn} 0.3s ease-out;
`;

export const CardContainer = styled.button`
  border: none;
  outline: none;
  cursor: pointer;
  text-align: left;
  background-color: #001325;
  overflow: hidden;
  width: 100%;
  position: relative;
  height: 116px;
  min-height: 116px;
  display: flex;
  align-items: stretch;

  &:active {
    opacity: 0.95;
  }
`;

export const BannerImage = styled.img`
  position: absolute;
  right: 24px;
  top: 0;
  height: 100%;
  width: auto;
  object-fit: contain;
  object-position: right center;
  z-index: 0;
`;

export const TextSection = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.spacing80};
  z-index: 1;
  flex: 1;
  max-width: 55%;
  gap: ${({ theme }) => theme.spacing.spacing20};
`;

export const Title = styled.span`
  ${({ theme }) => theme.typography.type100};
  color: ${({ theme }) => theme.colors.surface};
  letter-spacing: 0.1px;
`;

export const Description = styled.span`
  ${({ theme }) => theme.typography.type121};
  color: ${({ theme }) => theme.colors.surface};
  margin: 0;
`;

export const CTAButton = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${({ theme }) => theme.colors.surface};
  border-radius: ${({ theme }) => theme.borders.radius10};
  padding: ${({ theme }) => theme.spacing.spacing20};
  ${({ theme }) => theme.typography.type102};
  color: ${({ theme }) => theme.colors.surface};
  background: transparent;
  cursor: pointer;
  width: fit-content;
  margin-top: ${({ theme }) => theme.spacing.spacing20};
`;

export const CardWrapper = styled.div`
  position: relative;
`;
